import React from 'react';

const About = () => {
  return (
    <div>
      <h1>About This App</h1>
      <p className='my-1'>
        This is app recieved posts from CFBS licenses products to manage client
        and app status. There is also an Accounts Recievable component to this
        app that will allow CFBS apps to be turned on or off based on client
        account postions (arrears or current).
      </p>
      <p className='bg-dark p'>
        <strong>Version:</strong> 1.0.0
      </p>
    </div>
  );
};

export default About;
